import React from 'react';
import { Button, Col, Modal, ModalBody, Row } from 'react-bootstrap';
import Blockquote from '../../../components/Blockquote/Blockquote';
import ModalHeader from '../../../components/ModalHeader';
import PricingCalculatorCard, {
  PricingCardListItem,
} from '../../../components/PricingCalculatorCard';
import { RadioGroup } from '../../../components/Radio';
import { DateFormats, formatDate } from '../../../utils/utils';

export type customChangeHSAContributionsModalProps = {
  showChangeHSAContributionsModal: boolean;
  prePayItems: PricingCardListItem[];
  oneTimeItems: PricingCardListItem[];
  setOneTimeItems: (items: PricingCardListItem[]) => void;
  setPrePayItems: (items: PricingCardListItem[]) => void;
  handleCloseChangeHSAContributionsModal: () => void;
  handleShowSuccessDialog?: () => void;
};
const ChangeHSAContributionsModal = ({
  showChangeHSAContributionsModal,
  prePayItems,
  oneTimeItems,
  setOneTimeItems,
  setPrePayItems,
  handleCloseChangeHSAContributionsModal,
  handleShowSuccessDialog,
}: customChangeHSAContributionsModalProps) => {
  const [radioButtonValue, setRadioButtonValue] = React.useState<
    string | number
  >(0);

  const handleRadioButtonValue = (e: string | number) => {
    setRadioButtonValue(e);
  };

  const handleChangePrePayItems = (value: number | undefined) => {
    handleInputValueChange(value, prePayItems, setPrePayItems);
  };

  const handleChangeOneTimeItems = (value: number | undefined) => {
    handleInputValueChange(value, oneTimeItems, setOneTimeItems);
  };

  const handleCloseModal = () => {
    handleCloseChangeHSAContributionsModal();
    setRadioButtonValue(0);
  };

  const handleInputValueChange = (
    value: number | undefined | null,
    listItems: Array<PricingCardListItem>,
    setListItems: Function
  ) => {
    let listItemsNew = listItems;
    if (listItemsNew[0]) {
      listItemsNew[0].value = value;
    } else {
      listItemsNew[0] = {
        text: '',
        value: value,
      };
    }
    setListItems(listItemsNew);
  };

  return (
    <Modal
      show={showChangeHSAContributionsModal}
      onHide={handleCloseChangeHSAContributionsModal}
      dialogClassName="modal-xl"
      className="custom-change-hsa-contributions-modal"
    >
      <ModalHeader>
        <h4 className="text-sm-20-lg-32">Change HSA Contributions</h4>
      </ModalHeader>
      <ModalBody>
        <Row className="sub-header">
          <p className="header-text">
            Would you like to change your current per-pay-period contribution or
            make a one-time contribution?
          </p>
        </Row>
        <Row className="m-0 pb-12">
          <Blockquote>
            <span className="lh-xs">
              Note: Since you are age 55 by December 31 of this year, you're
              eligible for the catch-up contribution which means the{' '}
              {formatDate(new Date(), DateFormats.ONLY_YEAR)} IRS maximum
              contribution is $4,450 for individuals or $8,100 for families.
            </span>
          </Blockquote>
        </Row>
        <Row className="m-0 pb-12">
          <RadioGroup
            name={'hsa-contributions'}
            value={radioButtonValue}
            onChange={handleRadioButtonValue}
          >
            <PricingCalculatorCard
              title="Change per-pay-period contribution."
              radioButtonValue={1}
              listItems={prePayItems}
              handleChange={handleChangePrePayItems}
              selected={radioButtonValue === 1}
              className="p-0"
              resultText={`Total Estimated Contributions for ${formatDate(
                new Date(),
                DateFormats.ONLY_YEAR
              )}`}
              errorText="Contribution exceeds allowable limits of $4,450 or $8,100 for families."
              prePaidCalculation={false}
              isCollapsedView={radioButtonValue !== 1}
            />
            <PricingCalculatorCard
              title="Make a one-time contribution"
              radioButtonValue={2}
              listItems={oneTimeItems}
              handleChange={handleChangeOneTimeItems}
              selected={radioButtonValue === 2}
              className="p-0"
              prePaidCalculation={false}
              resultText={`Total Estimated Contributions for ${formatDate(
                new Date(),
                DateFormats.ONLY_YEAR
              )}`}
              isCollapsedView={radioButtonValue !== 2}
            />
          </RadioGroup>
        </Row>
        <Row className="pb-12">
          <Col className="d-flex justify-content-end">
            <Button
              onClick={handleCloseModal}
              className="text-nowrap"
              variant="primary-outline"
            >
              Cancel
            </Button>
          </Col>
          <Col className="d-flex justify-content-start">
            <Button
              onClick={() => {
                handleCloseModal();
                if (handleShowSuccessDialog) handleShowSuccessDialog();
              }}
              className="text-nowrap"
              variant="primary"
            >
              Complete
            </Button>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default ChangeHSAContributionsModal;
